import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Plus } from 'react-feather';
import { SelectPolicyRenewalLoaded } from 'actions';
import {
  getComparePolicyRoute,
  getPolicyDetailsRoute,
  getUpcomingRenewal,
  routeReplaceId,
} from 'helpers';
import history from 'helpers/history';
import { CheckupIcon } from 'components/svgs/CheckupIcon';
import { FilesIcon } from 'components/svgs/FilesIcon';
import { DashboardIcon } from 'components/svgs/DashboardIcon';
import { MarketScanIcon } from 'components/svgs/MarketScanIcon';
import {
  RENEWAL_UPLOAD_ROUTE,
  RENEWAL_MANUAL_ROUTE,
  POLICY_DETAILS_DOCS_ROUTE,
  HOME_ROUTE,
} from 'constants/routes';
import { MobileBottomNav } from 'containers/layout';
import styles from '../styles/PolicyDetailsMobileNav.module.scss';

const PolicyDetailsMobileNav = (props) => {
  const {
    allowMarketScan,
    policy,
    pendingRenewal,
    renewals,
    selectedRenewal,
    showRenewal,
  } = props;
  const policyId = policy?.id;

  const dispatch = useDispatch();
  const items = useMemo(() => {
    let activeItems = [];

    const myDocsRoute = {
      route: routeReplaceId(POLICY_DETAILS_DOCS_ROUTE, policyId),
      exact: true,
      icon: FilesIcon,
      label: 'My documents',
      className: styles.navOne,
    };

    if (pendingRenewal || policy.policyRenewalAdded) {
      activeItems = [
        {
          route: HOME_ROUTE,
          exact: true,
          icon: DashboardIcon,
          label: 'Dashboard',
          className: styles.house,
        },
        myDocsRoute,
        {
          icon: Plus,
          active: !!selectedRenewal,
          label: policy.policyRenewalAdded
            ? 'Edit renewal'
            : 'Continue renewal',
          onClick: () => {
            const renewal = policy.policyRenewalAdded
              ? getUpcomingRenewal(renewals)
              : R.assoc('isUpload', true, pendingRenewal);
            history.push(getPolicyDetailsRoute(policyId));
            dispatch(SelectPolicyRenewalLoaded(renewal));
          },
          className: styles.navTwo,
        },
      ];
    } else if (showRenewal) {
      activeItems = [
        myDocsRoute,
        {
          route: routeReplaceId(RENEWAL_UPLOAD_ROUTE, policyId),
          exact: true,
          icon: Plus,
          label: 'Upload renewal',
          className: styles.navTwo,
        },
        {
          route: routeReplaceId(RENEWAL_MANUAL_ROUTE, policyId),
          exact: true,
          icon: CheckupIcon,
          label: 'Enter renewal',
          className: styles.navThree,
        },
      ];
    } else {
      activeItems = [
        {
          route: HOME_ROUTE,
          exact: true,
          icon: DashboardIcon,
          label: 'Dashboard',
          className: styles.house,
        },
        myDocsRoute,
      ];
    }

    if (allowMarketScan) {
      activeItems.push({
        exact: false,
        route: getComparePolicyRoute(policy.id),
        icon: MarketScanIcon,
        label: 'Compare policy',
        className: styles.marketScan,
      });
    }

    return activeItems;
  }, [props]);

  return <MobileBottomNav items={items} />;
};

export default React.memo(PolicyDetailsMobileNav);
